// Types
import { GetConferencesResult } from '@domui-use-cases/districts/conferences/type';

export default (conferences: GetConferencesResult[], year: number) =>
  conferences.filter(item => Number(item.relatedRotaryYear) === year);
